/**
 * 区域组件：城市
 * @Author: FJJ
 * @History:
 * @Date      Version Remarks
 * ========= ======= ======================================================
 * 2023.07.12      1.0     First version
 *
 *
 * Copyright 2023, all rights reserved. Essa.cn
 */
import React from 'react';
import { Select, Row,Col } from 'antd';
import Lang from "@components/Lang/Lang";
import {isEmpty, isEmptyObject,} from '@utils/utils';
import RegionService from "../Region.action";
import CitySelect from "./citySelect"

const { Option } = Select;
export default class City extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            listCountry :[],
            listCity: [],
            loading: false,
            initCountry:"",
            initCity:""
        }
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 请求 国家列表
     * */
    getCountryList(){
        const sUrl = "/service/mg/whs/logistics/company/countryAndCity";
        this.loading(true)
        RegionService.postHttpAction(sUrl,{},).then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));
    }
    handleRes(resData){
            let { success, valid, models, } = resData;
            this.loading(false)
            if (success && valid) {
                if(models&&models.length>0){
                    const { initValue={},name } = this.props;
                    // const curId = initValue[name] || initValue.countries;
                    // if(!isEmpty(curId)){
                    //     const current = models.find(item=>item.countryId==curId)||{};
                    //     if(!isEmptyObject(current)){
                    //         // console.log("countries current",current)
                    //         // subList = current.countryList ||[]
                    //         // this.getCity(curId,initValue.cityCode)
                    //     }
                    // }
                    this.setState({
                        listCountry : models||[],
                        initCountry:initValue[name]||initValue.countries,
                        listCity : [],
                    })
                }
            }
    }

    /**
     * 选择国家
     * */
    handleCountryChange = (value,option) => {
        console.log("handleCountryChange,optio",value,option)
        if(option&&option.cityList){
            this.setState({
                listCity: option.cityList
            },()=>{
                if(this.onCityChild)this.onCityChild.reInit()
            })
        }else {
            this.setState({
                listCity: []
            },()=>{
                if(this.onCityChild)this.onCityChild.init()
            })
        }

    };
    /**
     * 选择城市
     * */
    handleCityChange =  (value,option) => {
        console.log("handleCityChange,optio",value,option)
        if(option&&option.props) {

        }else {

        }
    };
    // 选择 下拉
    onChangeBack(sKey,data){
        console.log("handleCityChange,optio",sKey,data)
        // const { value } = this.state;
        // value[sKey] = data;
        // this.setState({
        //     value:value
        // })
    }
    componentWillMount() {
        this.getCountryList()
    }
    onRefOne = (ref) =>  this.onCityChild = ref;
    componentDidMount() {
        if( this.props.onRef) this.props.onRef(this);
    }
    componentWillUnmount(){
        clearTimeout(this.cTimer);
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { initValue } = this.props;
        const { listCountry, listCity, loading, } = this.state;
        return (<>
                <Select style={{width:"100%"}}
                           allowClear
                           size="large"
                           loading={loading}
                           placeholder={Lang({id:"QingXuanZeGuoJia2"})}
                           onChange={this.handleCountryChange} >
                    {listCountry.map(country => (
                        <Option key={country.countryCode}
                                cityList={country.cityList}
                                value={country.countryCode}>
                            {country.countryName}
                        </Option>
                    ))}
                </Select>
                <CitySelect onChangeBack={(res)=>this.props.onChangeCity(res)} //回调到上级值
                            onRef={this.onRefOne}
                            placeholder={Lang({id:"QingXuanZeChengShi"})} // 请选择城市
                            list={listCity}
                            //keyLabel={"cityName"} keyValue={"cityCode"}
                            hasList={initValue||[]}
                />
            </>)
    }
}
